import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { toast } from 'sonner';
import axios from 'axios';
import { Download, Loader2, FileJson } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const DataExportButton = ({ variant = "outline", className = "", showIcon = true }) => {
  const { token } = useAuth();
  const [loading, setLoading] = useState(false);

  const headers = { Authorization: `Bearer ${token}` };

  const handleExportData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/api/gdpr/export`, { headers });
      
      // Create and download JSON file
      const dataStr = JSON.stringify(response.data.data, null, 2);
      const blob = new Blob([dataStr], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `mes_donnees_drbooking_${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      toast.success('Vos données ont été téléchargées avec succès');
    } catch (error) {
      toast.error('Erreur lors de l\'export des données');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button 
      variant={variant}
      className={`gap-2 ${className}`}
      onClick={handleExportData}
      disabled={loading}
      data-testid="export-data-btn"
    >
      {loading ? (
        <>
          <Loader2 className="w-4 h-4 animate-spin" />
          Export en cours...
        </>
      ) : (
        <>
          {showIcon && <Download className="w-4 h-4" />}
          Télécharger mes données
        </>
      )}
    </Button>
  );
};

export default DataExportButton;
